import React from 'react';
import HomeGameSelection from '../scroll/slot_scroll_line.js';
import { useTranslation } from 'react-i18next';

function HomeScrollGames({ isLogged, onOpenLogin, casinoSections }) {
  const {t} = useTranslation();

  return (
    <div className='container-fluid gamebox-home'>
      <div className='row'>      
        {!casinoSections['casino'] ? <HomeGameSelection limit="12" selection_name={t('Slot')} category_id="casino" isLogged={isLogged} onOpenLogin={onOpenLogin} /> : ''}
        {!casinoSections['casino_live'] ? <HomeGameSelection limit="12" selection_name={t('Casino_live')} category_id="casino-live" isLogged={isLogged} onOpenLogin={onOpenLogin} /> : ''}
        {!casinoSections['crash_games'] ? <HomeGameSelection limit="12" selection_name={t('Crash_game')} category_id="crash-game" isLogged={isLogged} onOpenLogin={onOpenLogin} /> : ''}
        {!casinoSections['bingo'] ? <HomeGameSelection limit="12" selection_name={t('Bingo')} category_id="bingo" isLogged={isLogged} onOpenLogin={onOpenLogin} /> : ''}
        {!casinoSections['virtual'] ? <HomeGameSelection limit="12" class_col="col-12" custom_class="full-width-home-game" selection_name={t('Virtual')} category_id="virtual" isLogged={isLogged} onOpenLogin={onOpenLogin} /> : ''}
      </div>
    </div>
  );
}

export default HomeScrollGames;
